'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = exports.ValidationEvent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = require('keycode');

var _keycode2 = _interopRequireDefault(_keycode);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _contains = require('dom-helpers/query/contains');

var _contains2 = _interopRequireDefault(_contains);

var _activeElement = require('dom-helpers/activeElement');

var _activeElement2 = _interopRequireDefault(_activeElement);

var _ownerDocument = require('dom-helpers/ownerDocument');

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _validators = require('./validators');

var _context3 = require('../util/context');

var _context4 = _interopRequireDefault(_context3);

var _InputDataList = require('./InputDataList');

var _InputDataList2 = _interopRequireDefault(_InputDataList);

var _ArrowDropDown = require('../SvgIcon/ArrowDropDown');

var _ArrowDropDown2 = _interopRequireDefault(_ArrowDropDown);

var _ArrowDropUp = require('../SvgIcon/ArrowDropUp');

var _ArrowDropUp2 = _interopRequireDefault(_ArrowDropUp);

var _IconButton = require('../IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ValidationEvent = exports.ValidationEvent = function () {
  function ValidationEvent(target) {
    var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var options = arguments[2];

    _classCallCheck(this, ValidationEvent);

    Object.assign(this, Object.assign({}, options, {
      type: 'validation',
      target: target,
      errors: errors,
      hasErrors: errors.length !== 0
    }));
  }

  return ValidationEvent;
}();

function normalizeErrors(errorMessage) {
  var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return (errors instanceof Array ? errors : [errors]).map(function (error) {
    return typeof error === 'boolean' ? errorMessage : (typeof error === 'undefined' ? 'undefined' : _typeof(error)) === 'object' ? error.errorMessage : error;
  });
}

var nextID = function () {
  var next = 0;
  return function () {
    return 'input-' + ++next;
  };
}();

var defaultValidators = (0, _validators.createValidators)(function (validators) {
  return {
    exactMatch: validators.exactMatch,
    email: validators.email,
    length: validators.length,
    required: validators.required
  };
});

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Input', function (theme) {
  return {
    wrapper: {
      position: 'relative',
      minWidth: 0,
      width: theme.typography.rhythmByPixel(176),
      padding: theme.variables.borderWidthFocused,
      backgroundColor: theme.palette.background.paper
    },
    formControl: {
      marginTop: theme.variables.formControlMarginTop,
      marginBottom: theme.variables.formControlMarginBottom
    },
    inkbar: {
      '&:after': {
        backgroundColor: theme.palette.accent.A200,
        left: 0,
        bottom: -1,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 2,
        position: 'absolute',
        width: '100%',
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.shorter,
          easing: theme.transitions.easing.easeOut
        })
      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      }
    },
    focused: {},
    fullWidth: {
      width: '100%',
      boxSizing: 'border-box'
    },
    error: {
      backgroundColor: theme.palette.grey[50],
      '&:after': {
        backgroundColor: theme.palette.error[500],
        transform: 'scaleX(1)' // Error is always underlined in red
      }
    },
    input: Object.assign({
      font: 'inherit',
      padding: 0,
      border: 0,
      display: 'block',
      width: '100%',
      verticalAlign: 'middle',
      whiteSpace: 'normal',
      background: 'none',
      minWidth: 0,
      minHeight: theme.variables.inputHeight,
      appearance: 'textfield', // Improve type search style.
      color: theme.palette.text.primary,
      cursor: 'text',
      '&:focus': {
        outline: 0
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        appearance: 'none'
      }
    }, theme.mixins.placeholder({
      color: theme.palette.text.secondary
    })),
    inputBold: Object.assign({}, theme.typography.body2, {
      lineHeight: theme.variables.inputHeight
    }),
    inputCenter: {
      textAlign: 'center'
    },
    inputContent: {
      display: 'flex',
      position: 'relative'
    },
    inputPadding: {
      paddingRight: theme.typography.rhythmByUnit(1),
      paddingLeft: theme.typography.rhythmByUnit(1)
    },
    readOnly: {
      cursor: 'default'
    },
    disabled: {
      color: theme.palette.text.disabled,
      cursor: 'not-allowed'
    },
    border: Object.assign({}, theme.mixins.border({
      '&$disabled': theme.mixins.borderDisabled(),
      '&$error, &$focused': theme.mixins.borderFocused(),
      '&$error': theme.mixins.borderError()
    }), {
      borderRadius: theme.variables.inputBorderRadius
    }),
    inlineActionContainer: {
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'flex-end',
      position: 'relative',
      height: theme.variables.inputHeight,
      cursor: 'pointer'
    },
    inlineAction: {
      height: '100%',
      width: '1em',
      borderRadius: 0,
      fontSize: '1.3em'
    },
    inlineActionBlur: {
      color: theme.palette.text.divider,
      '&:hover': {
        color: 'inherit'
      }
    },
    datalist: {
      top: '100%'
    },
    shadow: {
      resize: 'none',
      // Visibility needed to hide the extra text area on ipads
      visibility: 'hidden',
      position: 'absolute',
      whiteSpace: 'nowrap',
      minWidth: theme.variables.inputHeight,
      maxWidth: '100%',
      width: 'auto',
      paddingRight: theme.variables.borderFocusedWidth, // Offset border-right for IE11
      paddingLeft: theme.variables.borderFocusedWidth // Offset border-left for IE11
    },
    shadowNumber: {
      paddingRight: theme.typography.rhythmByUnit(1),
      paddingLeft: theme.typography.rhythmByUnit(1)
    },
    shadowNumberPlaceholder: {
      paddingRight: theme.typography.rhythmByUnit(2),
      paddingLeft: theme.typography.rhythmByUnit(2)
    },
    shadowTextArea: {
      // Overflow also needed to here to remove the extra row
      // added to textareas in Firefox.
      overflow: 'hidden'
    },
    resize: {
      width: 'auto',
      backgroundColor: 'transparent'
    },
    resizeInput: {
      width: '1em',
      textOverflow: 'ellipsis',
      maxWidth: theme.typography.rhythmByPixel(320),
      boxSizing: 'content-box'
    }
  };
});
/**
 * Input
 */
var Input = (_temp2 = _class = function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false,
      updated: false
    }, _this.input = null, _this.focus = function () {
      return _this.input.focus();
    }, _this.selection = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$start = _ref2.start,
          start = _ref2$start === undefined ? 0 : _ref2$start,
          end = _ref2.end;

      _this.input.selectionStart = start;
      _this.input.selectionEnd = end || start;
    }, _this.handleFocus = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this.setState({ focused: true });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleBlur = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (_this.hasFocus(event.relatedTarget)) return;
      var isDirty = _this.props.isDirty;

      var updated = _this.state.updated || isDirty(_this.props) || isDirty(_this.input || {});
      _this.setState({ datalist: false, focused: false, updated: updated });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      var onKeyDown = _this.props.onKeyDown;

      if (_this.state.datalist) {
        switch ((0, _keycode2['default'])(event)) {
          case 'down':
            _this.datalist.selectItem();
            return;
        }
      }

      if (onKeyDown) onKeyDown(event);
    }, _this.isDirty = function () {
      var isDirty = _this.props.isDirty;

      return isDirty(_this.props) || isDirty(_this.input || {});
    }, _this.setValue = function (value) {
      if (!_this.isControlled() && _this.input) {
        _this.input.value = value;
      }
      _this.handleChange({ target: { value: value } });
    }, _this.getValue = function (props) {
      return _this.isControlled(props) ? (props || _this.props).value : (_this.input || { value: '' }).value;
    }, _this.getStyle = function () {
      var _this$props = _this.props,
          resize = _this$props.resize,
          inputStyle = _this$props.inputStyle;

      if (!resize) return inputStyle || {};
      var width = _this.state.width;

      return { width: width };
    }, _this.handleResize = function () {
      var _this$props2 = _this.props,
          resize = _this$props2.resize,
          placeholder = _this$props2.placeholder;


      if (!resize) return;

      var value = _this.getValue() || placeholder;

      if (value !== undefined) _this.shadow.innerText = value + '.';

      _this.setState({
        width: _this.shadow.scrollWidth
      });
    }, _this.handleChange = function (event) {
      _this.handleResize(event);
      if (!_this.isControlled()) {
        _this.checkDirty(_this.input);
      }
      var getInputValue = _this.props.getInputValue;

      _this.checkValidity(Object.assign({}, _this.props, { value: getInputValue(_this.input) }));
      _this.checkDatalist();

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    }, _this.id = nextID(), _this.handleDatalistShow = function () {
      _this.setState({ datalist: true, filter: false });
      _this.focus();
      var onDatalistShow = _this.props.onDatalistShow;

      onDatalistShow();
    }, _this.handleDatalistClose = function () {
      _this.setState({ datalist: false });
      _this.focus();
      var onDatalistClose = _this.props.onDatalistClose;

      onDatalistClose();
    }, _this.handleSelectItem = function (e) {
      _this.setValue(e);
      _this.setState({ datalist: false, selected: true, value: e });
      _this.focus();
      var onDatalistSelectItem = _this.props.onDatalistSelectItem;

      onDatalistSelectItem(e);
    }, _this.state = {
      datalist: false,
      filter: true,
      focused: false,
      selected: false,
      updated: false,
      width: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Input, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        if (this.isControlled()) {
          this.checkDirty(this.props);
        }
        this.checkValidity();
        this.attach();
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        _context4['default'].clearInterval(this.inputPoller);
        this.detach();
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        if (!this.isControlled()) {
          this.checkDirty(this.input);
        }
        this.checkValidity();

        // React on IE11 has a lot of issues with not firing onChange, including issues
        // with pasting into fields, browser autofill, and password fields.
        // This solution comes from https://github.com/facebook/react/issues/1159#issuecomment-264225754
        var _props = this.props,
            getInputValue = _props.getInputValue,
            component = _props.component; // Used by `FileInput` to provide special `input.value`

        var isFileField = component && component.displayName === 'FileInput';
        this.inputPoller = _context4['default'].setInterval(function () {
          if (!_this2.input || (0, _isEqual2['default'])(_this2._previousValue, getInputValue(_this2.input))) {
            return;
          }
          _this2._previousValue = getInputValue(_this2.input);

          var event = void 0;
          if (typeof _context4['default'].Event === 'function') {
            // eslint-disable-next-line no-undef
            event = new Event('input', {
              bubbles: true,
              cancelable: true
            });
            _this2.input.dispatchEvent(event);
          } else if (typeof _context4['default'].CustomEvent === 'function') {
            _this2.input.addEventListener('inputPoller', _this2.handleChange);
            // eslint-disable-next-line no-undef
            var _event = new CustomEvent('inputPoller', {
              bubbles: true,
              cancelable: true
            });
            if (isFileField) return;
            _this2.input.dispatchEvent(_event);
          } else {
            event = _context4['default'].document.createEvent('Events');
            event.initEvent('input', true, true);
            _this2.input.dispatchEvent(event);
          }
        }, 20);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUpdate',
    value: function () {
      function componentWillUpdate(nextProps, nextState, nextContext) {
        if (this.isControlled(nextProps)) {
          this.checkDirty(nextProps);
        }
        var getInputValue = this.props.getInputValue;

        this.checkValidity(Object.assign({}, nextProps, { value: getInputValue(this.input) }), nextContext);
      }

      return componentWillUpdate;
    }()

    // Holds the input reference

  }, {
    key: 'attach',
    value: function () {
      function attach() {
        var _context$muiForm = this.context.muiForm;
        _context$muiForm = _context$muiForm === undefined ? {} : _context$muiForm;
        var _context$muiForm$atta = _context$muiForm.attach,
            attach = _context$muiForm$atta === undefined ? function () {} : _context$muiForm$atta;

        return attach(this);
      }

      return attach;
    }()
  }, {
    key: 'detach',
    value: function () {
      function detach() {
        var _context$muiForm2 = this.context.muiForm;
        _context$muiForm2 = _context$muiForm2 === undefined ? {} : _context$muiForm2;
        var _context$muiForm2$det = _context$muiForm2.detach,
            detach = _context$muiForm2$det === undefined ? function () {} : _context$muiForm2$det;

        return detach(this);
      }

      return detach;
    }()
  }, {
    key: 'hasFocus',
    value: function () {
      function hasFocus(el) {
        var currentFocus = el || (0, _activeElement2['default'])((0, _ownerDocument2['default'])(_reactDom2['default'].findDOMNode(this.wrapper))); // eslint-disable-line react/no-find-dom-node
        return currentFocus && this.wrapper && (0, _contains2['default'])(this.wrapper, currentFocus);
      }

      return hasFocus;
    }()
  }, {
    key: 'isControlled',
    value: function () {
      function isControlled(props) {
        return typeof (props || this.props).value === 'string';
      }

      return isControlled;
    }()
  }, {
    key: 'hasControlledErrors',
    value: function () {
      function hasControlledErrors(props, context) {
        var _getPropsWithContext = this.getPropsWithContext(props, context),
            errorProp = _getPropsWithContext.error;

        return !!errorProp;
      }

      return hasControlledErrors;
    }()
  }, {
    key: 'getControlledErrors',
    value: function () {
      function getControlledErrors(props, context) {
        var _getPropsWithContext2 = this.getPropsWithContext(props, context),
            errorProp = _getPropsWithContext2.error,
            errorMessageProp = _getPropsWithContext2.errorMessage;

        return normalizeErrors(errorMessageProp, errorProp);
      }

      return getControlledErrors;
    }()
  }, {
    key: 'getPropsWithContext',
    value: function () {
      function getPropsWithContext(nextProps, nextContext) {
        var props = nextProps || this.props;
        var context = nextContext || this.context;
        var _context$muiFormContr = context.muiFormControl,
            muiFormControl = _context$muiFormContr === undefined ? {} : _context$muiFormContr;

        var value = props.value || (this.input || {}).value;
        return Object.assign({}, muiFormControl, props, { value: value });
      }

      return getPropsWithContext;
    }()
  }, {
    key: 'getErrors',
    value: function () {
      function getErrors(props, context) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        var validate = _validators.selectValidators.apply(undefined, args);
        var errors = validate(this.getPropsWithContext(props, context));
        return errors;
      }

      return getErrors;
    }()
  }, {
    key: 'hasError',
    value: function () {
      function hasError() {
        var errorProp = this.props.error;
        var errorState = this.state.error;

        return this.hasControlledErrors() ? errorProp : errorState;
      }

      return hasError;
    }()
  }, {
    key: 'isUpdated',
    value: function () {
      function isUpdated() {
        return this.state.updated;
      }

      return isUpdated;
    }()
  }, {
    key: 'checkValidity',
    value: function () {
      function checkValidity(nextProps, nextContext) {
        var forceDirty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isDirty = this.props.isDirty;

        var props = this.getPropsWithContext(nextProps, nextContext);
        var isUpdated = this.isUpdated();
        var dirty = forceDirty || props.forceDirty || isDirty(props) || isDirty(this.input || {}) || isUpdated;
        // Empty and hasn't been updated
        if (!dirty) return [];

        if (!isUpdated) this.setState({ updated: true });

        var _props$id = props.id,
            id = _props$id === undefined ? this.id : _props$id,
            exactMatch = props.exactMatch,
            required = props.required,
            validator = props.validator,
            type = props.type,
            min = props.min,
            max = props.max;
        var _context = this.context,
            _context$muiFormContr2 = _context.muiFormControl,
            muiFormControl = _context$muiFormContr2 === undefined ? { onValidate: function () {
            function onValidate() {}

            return onValidate;
          }() } : _context$muiFormContr2,
            _context$muiForm3 = _context.muiForm,
            muiForm = _context$muiForm3 === undefined ? { onValidate: function () {
            function onValidate() {}

            return onValidate;
          }() } : _context$muiForm3;


        var email = type === 'email';
        var length = min !== undefined || max !== undefined;

        var controlled = this.hasControlledErrors(nextProps, nextContext);
        var errors = controlled ? this.getControlledErrors(nextProps, nextContext) : this.getErrors(nextProps, nextContext, defaultValidators, {
          required: required,
          email: email,
          exactMatch: exactMatch,
          length: length
        }, validator);

        if (!controlled) {
          var hasErrors = errors.length !== 0;
          if (this.state.error !== hasErrors) {
            this.setState({ error: hasErrors });
          }
        }

        var _props$onValidate = props.onValidate,
            onValidate = _props$onValidate === undefined ? function () {} : _props$onValidate;


        if (this.input) {
          var event = new ValidationEvent(this.input, errors, { id: id });
          onValidate(event);
          if (muiFormControl && muiFormControl.onValidate) {
            muiFormControl.onValidate(event);
          }
          if (muiForm && muiForm.onValidate) {
            muiForm.onValidate(event);
          }
        }

        return errors;
      }

      return checkValidity;
    }()
  }, {
    key: 'checkDirty',
    value: function () {
      function checkDirty(obj) {
        var muiFormControl = this.context.muiFormControl;
        var isDirty = this.props.isDirty;


        if (isDirty(obj)) {
          if (muiFormControl && muiFormControl.onDirty) {
            muiFormControl.onDirty();
          }
          if (this.props.onDirty) {
            this.props.onDirty();
          }
          return;
        }

        if (muiFormControl && muiFormControl.onClean) {
          muiFormControl.onClean();
        }
        if (this.props.onClean) {
          this.props.onClean();
        }
      }

      return checkDirty;
    }()
  }, {
    key: 'isAutoComplete',
    value: function () {
      function isAutoComplete(props) {
        return !!(props || this.props).autoComplete;
      }

      return isAutoComplete;
    }()
  }, {
    key: 'shouldShowDatalist',
    value: function () {
      function shouldShowDatalist(props, state) {
        var _ref3 = props || this.props,
            children = _ref3.children;

        var _ref4 = state || this.state || {},
            focused = _ref4.focused,
            selected = _ref4.selected;

        return !!(this.isAutoComplete(props) && !selected && focused && children);
      }

      return shouldShowDatalist;
    }()
  }, {
    key: 'checkDatalist',
    value: function () {
      function checkDatalist(props) {
        var _this3 = this;

        var value = this.getValue(props);
        var selected = false;
        var filter = true;
        var datalist = this.shouldShowDatalist(props);
        var nextState = { datalist: datalist, selected: selected, value: value, filter: filter };
        var keys = ['datalist', 'filter', 'selected', 'value'];

        if (!keys.every(function (k) {
          return nextState[k] === _this3.state[k];
        })) {
          this.setState(nextState);
        }
      }

      return checkDatalist;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _classNames,
            _classNames2,
            _classNames4,
            _this4 = this;

        var _props2 = this.props,
            children = _props2.children,
            bold = _props2.bold,
            classNameProp = _props2.className,
            ComponentProp = _props2.component,
            center = _props2.center,
            autoCompleteProp = _props2.autoComplete,
            inkbar = _props2.inkbar,
            inlineActionProp = _props2.inlineAction,
            inlineActionContainerClassName = _props2.inlineActionContainerClassName,
            inlineActionClassNameProp = _props2.inlineActionClassName,
            inputClassNameProp = _props2.inputClassName,
            disabled = _props2.disabled,
            errorProp = _props2.error,
            errorMessageProp = _props2.errorMessage,
            exactMatch = _props2.exactMatch,
            findInputNode = _props2.findInputNode,
            focusedProp = _props2.focused,
            fullWidth = _props2.fullWidth,
            forceDirty = _props2.forceDirty,
            placeholder = _props2.placeholder,
            getInputValue = _props2.getInputValue,
            inputStyle = _props2.inputStyle,
            isDirty = _props2.isDirty,
            readOnly = _props2.readOnly,
            requiredProp = _props2.required,
            resize = _props2.resize,
            onDatalistClose = _props2.onDatalistClose,
            onDatalistSelectItem = _props2.onDatalistSelectItem,
            onDatalistShow = _props2.onDatalistShow,
            margin = _props2.margin,
            onBlur = _props2.onBlur,
            onFocus = _props2.onFocus,
            onChange = _props2.onChange,
            onClean = _props2.onClean,
            onDirty = _props2.onDirty,
            onInput = _props2.onInput,
            onKeyDown = _props2.onKeyDown,
            onValidate = _props2.onValidate,
            overlay = _props2.overlay,
            textEntry = _props2.textEntry,
            type = _props2.type,
            underline = _props2.underline,
            validator = _props2.validator,
            value = _props2.value,
            wrapperStyle = _props2.wrapperStyle,
            other = _objectWithoutProperties(_props2, ['children', 'bold', 'className', 'component', 'center', 'autoComplete', 'inkbar', 'inlineAction', 'inlineActionContainerClassName', 'inlineActionClassName', 'inputClassName', 'disabled', 'error', 'errorMessage', 'exactMatch', 'findInputNode', 'focused', 'fullWidth', 'forceDirty', 'placeholder', 'getInputValue', 'inputStyle', 'isDirty', 'readOnly', 'required', 'resize', 'onDatalistClose', 'onDatalistSelectItem', 'onDatalistShow', 'margin', 'onBlur', 'onFocus', 'onChange', 'onClean', 'onDirty', 'onInput', 'onKeyDown', 'onValidate', 'overlay', 'textEntry', 'type', 'underline', 'validator', 'value', 'wrapperStyle']);

        var _context2 = this.context,
            muiFormControl = _context2.muiFormControl,
            muiForm = _context2.muiForm,
            styleManager = _context2.styleManager;
        var _state = this.state,
            datalist = _state.datalist,
            filter = _state.filter,
            focused = _state.focused;

        // Only a literal true should turn on autoComplete

        var autoComplete = autoCompleteProp === true;

        // Turn off system autoComplete if prop is boolean
        var componentAutoComplete = typeof autoCompleteProp === 'boolean' ? 'off' : autoCompleteProp;

        var border = muiForm && underline === undefined || underline;
        var required = requiredProp || muiFormControl && muiFormControl.required === true;
        var isFocused = focused || focusedProp;
        var classes = styleManager.render(styleSheet);
        var wrapperClassName = (0, _classnames2['default'])(classes.wrapper, (_classNames = {}, _defineProperty(_classNames, classes.formControl, muiFormControl && margin), _defineProperty(_classNames, classes.inkbar, inkbar), _defineProperty(_classNames, classes.focused, isFocused), _defineProperty(_classNames, classes.error, this.hasError()), _defineProperty(_classNames, classes.fullWidth, fullWidth), _defineProperty(_classNames, classes.border, border), _defineProperty(_classNames, classes.resize, resize), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.readOnly, readOnly), _classNames), classNameProp);
        var rootInputClassName = (0, _classnames2['default'])(classes.input, (_classNames2 = {}, _defineProperty(_classNames2, classes.inputCenter, center), _defineProperty(_classNames2, classes.inputPadding, border), _defineProperty(_classNames2, classes.inputBold, bold), _defineProperty(_classNames2, classes.disabled, disabled), _defineProperty(_classNames2, classes.readOnly, readOnly), _classNames2), inputClassNameProp);
        var inputClassName = (0, _classnames2['default'])(rootInputClassName, _defineProperty({}, classes.resizeInput, resize));
        var shadowClassName = (0, _classnames2['default'])(classes.shadow, (_classNames4 = {}, _defineProperty(_classNames4, classes.shadowNumber, type === 'number'), _defineProperty(_classNames4, classes.shadowNumberPlaceholder, type === 'number' && placeholder && this.getValue() === ''), _defineProperty(_classNames4, classes.shadowTextArea, ComponentProp === 'textarea'), _classNames4));
        var inlineActionClassName = (0, _classnames2['default'])(classes.inlineAction, _defineProperty({}, classes.inlineActionBlur, !isFocused));
        var inlineAction = _react2['default'].isValidElement(inlineActionProp) && _react2['default'].cloneElement(inlineActionProp, {
          className: (0, _classnames2['default'])(inlineActionClassName, inlineActionClassNameProp, inlineActionProp.props.className)
        });
        var style = this.getStyle();
        var datalistValue = filter ? this.getValue() : '';
        var isEditable = !disabled && !readOnly;

        return _react2['default'].createElement(
          'div',
          {
            className: wrapperClassName,
            ref: function () {
              function ref(c) {
                return _this4.wrapper = c;
              }

              return ref;
            }(),
            style: wrapperStyle
          },
          _react2['default'].createElement(
            'div',
            { className: classes.inputContent },
            _react2['default'].createElement(ComponentProp, _extends({
              'aria-required': required ? true : undefined,
              autoComplete: componentAutoComplete,
              className: inputClassName,
              onBlur: this.handleBlur,
              onChange: this.handleChange,
              onInput: onInput || this.handleChange,
              onFocus: this.handleFocus,
              onKeyDown: this.handleKeyDown,
              readOnly: readOnly || !textEntry,
              ref: function () {
                function ref(c) {
                  return _this4.input = findInputNode(c);
                }

                return ref;
              }()
            }, Object.assign({
              disabled: disabled,
              placeholder: placeholder,
              style: style,
              type: type,
              value: value
            }, other))),
            _react2['default'].createElement(
              'div',
              {
                className: (0, _classnames2['default'])(classes.inlineActionContainer, inlineActionContainerClassName)
              },
              isEditable && inlineAction,
              isEditable && !!children && !datalist && autoComplete && _react2['default'].createElement(
                _IconButton2['default'],
                {
                  className: inlineActionClassName,
                  onClick: this.handleDatalistShow,
                  tabIndex: '-1'
                },
                _react2['default'].createElement(_ArrowDropDown2['default'], null)
              ),
              isEditable && !!children && datalist && autoComplete && _react2['default'].createElement(
                _IconButton2['default'],
                {
                  className: inlineActionClassName,
                  onClick: this.handleDatalistClose,
                  tabIndex: '-1'
                },
                _react2['default'].createElement(_ArrowDropUp2['default'], null)
              )
            ),
            overlay,
            _react2['default'].createElement('span', { ref: function () {
                function ref(el) {
                  return _this4.shadow = el;
                }

                return ref;
              }(), className: shadowClassName })
          ),
          _react2['default'].createElement(
            _InputDataList2['default'],
            {
              ref: function () {
                function ref(c) {
                  return _this4.datalist = c;
                }

                return ref;
              }(),
              anchorEl: this.wrapper,
              className: classes.datalist,
              open: datalist,
              value: datalistValue,
              onSelectItem: this.handleSelectItem
            },
            children
          )
        );
      }

      return render;
    }()
  }]);

  return Input;
}(_react.Component), _class.displayName = 'Input', _class.propTypes = {
  /**
   * If 'true', input text will show autoComplete list
   */
  autoComplete: _PropTypes2['default'].oneOfType([_PropTypes2['default'].bool, _PropTypes2['default'].string]),
  bold: _PropTypes2['default'].bool,
  /**
   * If 'true', input text will be centered in input area
   */
  center: _PropTypes2['default'].bool,
  /**
   * Datalist children for autocompletion.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the wrapper element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The element or component used for the root node.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  disabled: _PropTypes2['default'].bool,
  error: _PropTypes2['default'].oneOfType([_PropTypes2['default'].bool, _PropTypes2['default'].string, _PropTypes2['default'].arrayOf(_PropTypes2['default'].string)]),
  errorMessage: _PropTypes2['default'].string,
  /**
   * If 'true', input must match value of datalist item. Only valid
   * if datalist values have been specified
   */
  exactMatch: _PropTypes2['default'].bool,
  /**
   * findInputNode: The func used to select an `input` node from the ref func
   */
  findInputNode: _PropTypes2['default'].func,
  /**
   * Whether the input should be displayed in a focused state.
   */
  focused: _PropTypes2['default'].bool,
  forceDirty: _PropTypes2['default'].bool,
  /**
   * If 'true', input will be expanded to full width
   */
  fullWidth: _PropTypes2['default'].bool,
  getInputValue: _PropTypes2['default'].func,
  inputStyle: _PropTypes2['default'].shape({ width: _PropTypes2['default'].number }),
  /**
   * If set to true, the input will have an inkbar.
   */
  inkbar: _PropTypes2['default'].bool,
  /**
   * A component representing one or more actions shown to the right of the field
   */
  inlineAction: _PropTypes2['default'].node,
  /**
   * The CSS class name of the inline action.
   */
  inlineActionClassName: _PropTypes2['default'].string,
  /**
   * The CSS class name of the inline action container.
   */
  inlineActionContainerClassName: _PropTypes2['default'].string,
  /**
   * The CSS class name of the input element.
   */
  inputClassName: _PropTypes2['default'].string,
  /**
   * isDirty: A func used to determine, based on `this.props`, if an `input` is dirty
   */
  isDirty: _PropTypes2['default'].func,
  /**
   * If true and context is muiFormControl then vertical margin applied
   */
  margin: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  onBlur: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  onChange: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  onClean: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  onDirty: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  onFocus: _PropTypes2['default'].func,
  /**
   * Called when datalist should be closed
   */
  onDatalistClose: _PropTypes2['default'].func,
  /**
   * Called when datalist should be shown
   */
  onDatalistShow: _PropTypes2['default'].func,
  /**
   * Called when datalist item has been selected
   */
  onDatalistSelectItem: _PropTypes2['default'].func,
  onKeyDown: _PropTypes2['default'].func,
  onInput: _PropTypes2['default'].func,
  /**
   * Called when input is validated
   */
  onValidate: _PropTypes2['default'].func,
  /**
   * Component used to represent the input value
   */
  overlay: _PropTypes2['default'].node,
  placeholder: _PropTypes2['default'].string,
  readOnly: _PropTypes2['default'].bool,
  /**
   * Dynamically resize input.
   */
  resize: _PropTypes2['default'].bool,
  required: _PropTypes2['default'].bool,
  /**
   * Whether text entry is permitted
   */
  textEntry: _PropTypes2['default'].bool,
  /**
   * Input type.
   */
  type: _PropTypes2['default'].string,
  /**
   * If set to true, the input will have a border.
   */
  underline: _PropTypes2['default'].bool,
  /**
   * Function that validates the current value
   */
  validator: _PropTypes2['default'].func,
  /**
   * The input value, required for a controlled component.
   */
  value: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].array]),
  wrapperStyle: _PropTypes2['default'].object
}, _class.defaultProps = {
  autoComplete: true,
  component: 'input',
  exactMatch: false,
  findInputNode: function () {
    function findInputNode(c) {
      return c;
    }

    return findInputNode;
  }(),
  getInputValue: function () {
    function getInputValue(i) {
      return i ? i.value : null;
    }

    return getInputValue;
  }(),
  isDirty: function () {
    function isDirty(obj) {
      return obj && obj.value && obj.value.length > 0;
    }

    return isDirty;
  }(),
  onDatalistClose: function () {
    function onDatalistClose() {}

    return onDatalistClose;
  }(),
  onDatalistSelectItem: function () {
    function onDatalistSelectItem() {}

    return onDatalistSelectItem;
  }(),
  onDatalistShow: function () {
    function onDatalistShow() {}

    return onDatalistShow;
  }(),
  margin: true,
  textEntry: true,
  type: 'text',
  inkbar: false
}, _class.contextTypes = {
  muiFormControl: _PropTypes2['default'].object,
  muiForm: _PropTypes2['default'].object,
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = Input;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Input/Input.js
// module id = 1650
// module chunks = 32